export default __webpack_public_path__ + "static/media/1g.c6abbd57.jpg";